import {createStore, combineReducers,applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import AsignaturaReducer from '../reducer/AsignaturasReducer';
import AuthReducer from '../reducer/AuthReducer';
import ContenidoReducer from '../reducer/ContenidoReducer';
import DocentesReducer from '../reducer/DocentesReducer';
import { fraseDelDiaReducer } from '../reducer/FraseDelDiaReducer';
import PerfilReducer from '../reducer/PerfilReducer';
import TemasReducer from '../reducer/TemasReducer';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const reducer = combineReducers({
    auth: AuthReducer,
    perfil: PerfilReducer,
    frase: fraseDelDiaReducer,
    asignaturas: AsignaturaReducer,
    temas: TemasReducer,
    contenido: ContenidoReducer,
    docentes: DocentesReducer
})


export const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(thunk))
)